/**
 * Configuration API Module
 * Handles loading of environment and navigation configurations
 */

import axiosClient from './client';
import { ProgramInformation, NavigationConfig, EnvironmentConfig } from './types';

// Configuration file paths
const ENV_CONFIG_PATH = './environments.json';
const NAV_CONFIG_PATH = './navigation.json';

// ============================================================================
// Environment Configuration
// ============================================================================

/**
 * Load environment configuration
 */
export async function getEnvironments(): Promise<ProgramInformation> {
  const response = await axiosClient.get<ProgramInformation>(ENV_CONFIG_PATH);
  return response.data;
}

/**
 * Get current environment configuration
 */
export function getCurrentEnvironment(): EnvironmentConfig | undefined {
  const environments = (window as any)['environments'];
  return environments;
}

/**
 * Store environment in global window object
 * (Required for legacy compatibility with iframes)
 */
export function setEnvironmentGlobal(env: ProgramInformation): void {
  const envKey = (process.env.REACT_APP_API_ENV || 'dev') as keyof ProgramInformation;
  const currentEnv = env[envKey];
  (window as any)['environments'] = currentEnv;
  (window as any)['version'] = env.version;
}

// ============================================================================
// Navigation Configuration
// ============================================================================

/**
 * Load navigation configuration
 */
export async function getNavigation(): Promise<NavigationConfig> {
  const response = await axiosClient.get<NavigationConfig>(NAV_CONFIG_PATH);
  return response.data;
}

// ============================================================================
// Program Parameters Configuration
// ============================================================================

/**
 * Load program parameters configuration
 * Always loads from ./pgm-parameters.json regardless of environment
 */
export async function getProgramParameters(): Promise<any> {
  const response = await axiosClient.get('./pgm-parameters.json');
  return response.data;
}
